import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 27 27",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M18 13.5V6.75c0-2.494-2.008-4.524-4.476-4.524-.08 0-.158.01-.235.029A4.507 4.507 0 0 0 9 6.75v6.75c0 2.482 2.018 4.5 4.5 4.5s4.5-2.018 4.5-4.5Zm-6.75 0V6.75c0-1.24 1.01-2.25 2.25-2.25.062 0 .123-.006.183-.017 1.153.085 2.067 1.069 2.067 2.267v6.75c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M6.75 13.5H4.5c0 4.581 3.444 8.366 7.875 8.922v2.328h2.25v-2.328c4.431-.556 7.875-4.34 7.875-8.922h-2.25a6.757 6.757 0 0 1-6.75 6.75 6.757 6.757 0 0 1-6.75-6.75Z"
	})]
});
export default SvgMicrophone;
